import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router'

import {
  GetPropostaDuplicarService,
  type TGetPropostaDuplicarResponse,
} from '@/features/proposta/brasil/http/get-proposta-duplicar.service'
import { handleRevisarDuplicarPropostaError, propostaKeys } from '@/features/proposta/brasil/utils'
import type { AxiosErrorMap } from '@/infra/http'

export const useDuplicarProposta = (numero: number) => {
  const navigate = useNavigate()

  return useMutation<TGetPropostaDuplicarResponse, AxiosErrorMap>({
    mutationKey: propostaKeys.duplicar(numero),
    mutationFn: async () => (await new GetPropostaDuplicarService().execute(numero)).data,
    onSuccess: () => navigate(`/proposta/${numero}/duplicar`),
    onError: (error) => handleRevisarDuplicarPropostaError(error, 'DUPLICAR'),
  })
}
